import {
  emptyOrganizationPersonalization,
  SysOrgPersonalizationNameType,
  type U2104Organization,
  type U2104OrganizationPersonalization,
} from "../../../../U2104Service";

export function getGoogleCalendarPersoValue(
  personalizations: U2104OrganizationPersonalization[] | undefined,
  code: string,
): string {
  const item = personalizations?.find((p) => p.personalizationName === code);
  return item?.personalizationValue ?? "";
}

export function setGoogleCalendarPersoValue(
  org: U2104Organization,
  code: string,
  value: string,
  scope: "admin" | "user",
): U2104Organization {
  const personalizations = [...(org.personalizations ?? [])];
  const idx = personalizations.findIndex((p) => p.personalizationName === code);
  if (idx >= 0) {
    personalizations[idx] = { ...personalizations[idx], personalizationValue: value };
  } else {
    personalizations.push({
      ...emptyOrganizationPersonalization,
      personalizationName: code,
      personalizationValue: value,
      scope,
    });
  }
  return { ...org, personalizations };
}

export function removeGoogleCalendarPerso(org: U2104Organization, code: string): U2104Organization {
  return {
    ...org,
    personalizations: (org.personalizations ?? []).filter((p) => p.personalizationName !== code),
  };
}

export const GOOGLE_CALENDAR_PERSO_CODES = {
  clientId: SysOrgPersonalizationNameType.ORG_GOOGLE_CALENDAR_CLIENT_ID,
  clientSecret: SysOrgPersonalizationNameType.ORG_GOOGLE_CALENDAR_CLIENT_SECRET,
  oauthRedirectUri: SysOrgPersonalizationNameType.ORG_GOOGLE_CALENDAR_OAUTH_REDIRECT_URI,
  oauthFrontendRedirectUrl: SysOrgPersonalizationNameType.ORG_GOOGLE_CALENDAR_OAUTH_FRONTEND_REDIRECT_URL,
  calendarId: SysOrgPersonalizationNameType.ORG_GOOGLE_CALENDAR_CALENDAR_ID,
  calendarIdDeliverable: SysOrgPersonalizationNameType.ORG_GOOGLE_CALENDAR_CALENDAR_ID_DELIVERABLE,
  eventTitleTemplate: SysOrgPersonalizationNameType.ORG_GOOGLE_CALENDAR_EVENT_TITLE_TEMPLATE,
} as const;

/** Secret présent en base (id+version) mais absent du GET — ne pas envoyer de valeur vide à l'update. */
export function hasGoogleCalendarClientSecretInForm(org: U2104Organization | null | undefined): boolean {
  const item = org?.personalizations?.find((p) => p.personalizationName === GOOGLE_CALENDAR_PERSO_CODES.clientSecret);
  return item != null && String(item.id).length > 0 && item.version != null && item.version > 0;
}
